/** Pure bounded mapping; no time-driven loop or 3D runtime. */
export function websitePointerPose(x, y) {
  const clamp = value => Math.max(-1, Math.min(1, Number.isFinite(value) ? value : 0));
  const nx = clamp(x), ny = clamp(y);
  return { x: nx * 7, y: ny * 5, rotateX: -ny * 2, rotateY: nx * 3 };
}

export function initWebsiteMotion(site) {
  const region = site?.querySelector('[data-website-scene]');
  const art = site?.querySelector('[data-website-art]');
  if (!region || !art) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  let visible = false, rect, frame = 0;
  const reset = () => {
    cancelAnimationFrame(frame); frame = 0; rect = null;
    art.style.removeProperty('transform');
  };
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    if (!visible) reset();
  });
  observer.observe(region);
  region.addEventListener('pointermove', event => {
    if (!visible || reduced.matches || !fine.matches || document.hidden) return;
    rect ||= region.getBoundingClientRect();
    const pose = websitePointerPose((event.clientX - rect.left) / rect.width * 2 - 1, (event.clientY - rect.top) / rect.height * 2 - 1);
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      art.style.transform = `perspective(900px) translate3d(${pose.x}px,${pose.y}px,0) rotateX(${pose.rotateX}deg) rotateY(${pose.rotateY}deg)`;
      frame = 0;
    });
  }, { passive: true });
  region.addEventListener('pointerleave', reset);
  window.addEventListener('resize', reset, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
  reduced.addEventListener('change', reset);
  fine.addEventListener('change', reset);
}
